import React from 'react';
import PromotionRedemption from '.';

const RedemptionStream = ({ member } = {}) => {
  return (
    <div className="page-content px-4 pb-4">
      <PromotionRedemption member={member} />
    </div>
  );
};
export default RedemptionStream;
